import React, { FC, useState } from 'react';
import styles from './assets/password-recovery-screen.module.scss';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import GeneralEnum from '../../../../enumerables/general-enum';
import { getValFromEnum } from '../../../../components/redux-form/utils/dropdown-values';
import MedicalReleaseOfInformationForm from './components/MedicalReleaseOfInformationForm';
import MedicalReleaseOfInformationSecondForm from './components/MedicalReleaseOfInformationSecondForm';
import MedicalReleaseOfInformationThirdForm from './components/MedicalReleaseOfInformationThirdForm';
import MedicalReleaseOfInformationFourthForm from './components/MedicalReleaseOfInformationFourthForm';
import MedicalReleaseOfInformationFifthForm from './components/MedicalReleaseOfInformationFifthForm';
import MedicalReleaseOfInformationSixthForm from './components/MedicalReleaseOfInformationSixthForm';
import Loader from '../../../../components/Loader';
import OfficePoliciesForm from './components/OfficePoliciesForm';
import InformedConsentForTestingForm from './components/InformedConsentForTestingForm';
import TelemedicineConsentForm from './components/TelemedicineConsentForm';
import TreatmentInformedConsentForm from './components/TreatmentInformedConsentForm';
import AbaIntakeForm from './components/AbaIntakeForm';
import ChildTreatmentQuestionnaireForm from './components/ChildTreatmentQuestionnaireForm';
import NeuropsychologyPatientForm from './components/NeuropsychologyPatientForm';
import ConsentTestingDoeCasesForm from './components/ConsentTestingDoeCasesForm';
import ReleaseOfHealthInformationPediatricianForm from './components/ReleaseOfHealthInformationPediatricianForm';
import ReleaseOfHealthInformationSchoolForm from './components/ReleaseOfHealthInformationSchoolForm';
import InformedConsentForVideoForm from './components/InformedConsentForVideoForm';
import WelcomePacketForm from './components/WelcomePacketForm';
import BriefBackgroundForm from './components/BriefBackgroundForm';
import TreatmentProcessForm from './components/TreatmentProcessForm';
import InformedExpectationForm from './components/InformedExpectationForm';
import CreditCardForm from './components/CreditCardForm';
import HealthInformationForm from './components/HealthInformationForm';
import ConsentForBiForm from './components/ConsentForBiForm';

export interface StateProps {}

export interface DispatchProps {}

export interface OwnProps {}

interface RouteParams {
    id: string;
    formId: string;
}
export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

interface State {
    step: number;
}

const IntakeParentScreen: FC<Props> = (props: Props) => {
    const {
        match: {
            params: { id, formId },
        },
    } = props;

    const [isLoader, setIsLoader] = useState(false);

    const [isOtherCommunication, setIsOtherCommunication] = useState(false);
    const [isOtherBehavior, setIsOtherBehavior] = useState(false);
    const [isOtherInterest, setIsOtherInterest] = useState(false);
    const [isOtherSocial, setIsOtherSocial] = useState(false);
    const [isHealthPlanOther, setIsHealthPlanOther] = useState(false);
    const [isHealthPlanOtherSchool, setIsHealthPlanOtherSchool] = useState(false);

    const [isSpecialEducation, setIsSpecialEducation] = useState(false);
    const [isReceiveCurrentTreatment, setIsReceiveCurrentTreatment] = useState(false);
    const [isPriorPsychiatricShow, setIsPriorPsychiatricShow] = useState(false);
    const [isPriorDiagnosisShow, setIsPriorDiagnosisShow] = useState(false);
    const [isPriorTreatmentShow, setIsPriorTreatmentShow] = useState(false);
    const [isBadHabitShow, setIsBadHabitShow] = useState(false);

    const [yesOne, setYesOne] = useState(false);
    const [yesTwo, setYesTwo] = useState(false);
    const [yesThree, setYesThree] = useState(false);

    const IntakeType = GeneralEnum ? GeneralEnum.getEnum('IntakeType') : {};
    const intakeTypeValues: SelectObject[] = getValFromEnum(IntakeType);

    const form = () => {
        switch (formId) {
            case '1':
                return (
                    <NeuropsychologyPatientForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '2':
                return (
                    <ChildTreatmentQuestionnaireForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                        setIsSpecialEducation={setIsSpecialEducation}
                        isSpecialEducation={isSpecialEducation}
                        setIsReceiveCurrentTreatment={setIsReceiveCurrentTreatment}
                        isReceiveCurrentTreatment={isReceiveCurrentTreatment}
                        setIsPriorPsychiatricShow={setIsPriorPsychiatricShow}
                        isPriorPsychiatricShow={isPriorPsychiatricShow}
                        setIsPriorDiagnosisShow={setIsPriorDiagnosisShow}
                        isPriorDiagnosisShow={isPriorDiagnosisShow}
                        setIsPriorTreatmentShow={setIsPriorTreatmentShow}
                        isPriorTreatmentShow={isPriorTreatmentShow}
                        setIsBadHabitShow={setIsBadHabitShow}
                        isBadHabitShow={isBadHabitShow}
                    />
                );
            case '3':
                return (
                    <AbaIntakeForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                        setIsOtherCommunication={setIsOtherCommunication}
                        isOtherCommunication={isOtherCommunication}
                        setIsOtherBehavior={setIsOtherBehavior}
                        isOtherBehavior={isOtherBehavior}
                        setIsOtherInterest={setIsOtherInterest}
                        isOtherInterest={isOtherInterest}
                        setIsOtherSocial={setIsOtherSocial}
                        isOtherSocial={isOtherSocial}
                    />
                );
            case '4':
                return (
                    <TreatmentInformedConsentForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '5':
                return (
                    <TelemedicineConsentForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '6':
                return (
                    <OfficePoliciesForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '7':
                return (
                    <MedicalReleaseOfInformationForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '8':
                return (
                    <MedicalReleaseOfInformationSecondForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '9':
                return (
                    <MedicalReleaseOfInformationThirdForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '10':
                return (
                    <MedicalReleaseOfInformationFourthForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '11':
                return (
                    <MedicalReleaseOfInformationFifthForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '12':
                return (
                    <MedicalReleaseOfInformationSixthForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '13':
                return (
                    <InformedConsentForTestingForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '14':
                return (
                    <ConsentTestingDoeCasesForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '15':
                return (
                    <ReleaseOfHealthInformationPediatricianForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsHealthPlanOther={setIsHealthPlanOther}
                        isHealthPlanOther={isHealthPlanOther}
                        setIsLoader={setIsLoader}
                    />
                );
            case '16':
                return (
                    <ReleaseOfHealthInformationSchoolForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsHealthPlanOtherSchool={setIsHealthPlanOtherSchool}
                        isHealthPlanOtherSchool={isHealthPlanOtherSchool}
                        setIsLoader={setIsLoader}
                    />
                );
            case '17':
                return (
                    <InformedConsentForVideoForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '18':
                return (
                    <WelcomePacketForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '19':
                return (
                    <BriefBackgroundForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '20':
                return (
                    <TreatmentProcessForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '21':
                return (
                    <InformedExpectationForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '22':
                return (
                    <CreditCardForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '23':
                return (
                    <HealthInformationForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                    />
                );
            case '24':
                return (
                    <ConsentForBiForm
                        initialValues={{
                            student: id,
                            formId,
                        }}
                        setIsLoader={setIsLoader}
                        setYesOne={setYesOne}
                        yesOne={yesOne}
                        setYesTwo={setYesTwo}
                        yesTwo={yesTwo}
                        setYesThree={setYesThree}
                        yesThree={yesThree}
                    />
                );
        }
    };

    return (
        <div className={classNames(styles.loginWrapper)}>
            <div className={classNames('container')}>
                {isLoader ? <Loader /> : null}
                <div className={classNames(styles.passwordRecovery, 'py-3')}>{form()}</div>
            </div>
        </div>
    );
};

export default IntakeParentScreen;
